import React, { useState, useEffect } from 'react';
import { Button } from "components/ui/button";
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#f5f5f0] border-b-4 border-black' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 bg-black flex items-center justify-center">
              <div className="w-4 h-4 bg-[#d4ff00] rotate-45" />
            </div>
            <span className="font-black text-xl text-black">Evolve</span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('features')}
              className="font-bold text-black hover:text-black/60 transition-colors"
            >
              Возможности
            </button>
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="font-bold text-black hover:text-black/60 transition-colors"
            >
              Как это работает
            </button>
            <Button
              onClick={() => scrollToSection('cta')}
              className="h-11 px-6 font-bold bg-[#d4ff00] text-black border-4 border-black rounded-none shadow-[4px_4px_0_0_#1a1a1a] hover:shadow-[6px_6px_0_0_#1a1a1a] hover:translate-x-[-2px] hover:translate-y-[-2px] hover:bg-[#c4ef00] transition-all"
            >
              Ранний доступ
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-11 h-11 bg-black flex items-center justify-center"
          >
            {isMobileMenuOpen ? (
              <X className="w-5 h-5 text-[#d4ff00]" />
            ) : (
              <Menu className="w-5 h-5 text-[#d4ff00]" />
            )}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="fixed inset-x-0 top-[72px] z-40 bg-[#f5f5f0] border-b-4 border-black p-6 md:hidden"
          >
            <div className="flex flex-col gap-4">
              <button
                onClick={() => scrollToSection('features')}
                className="font-bold text-lg text-black text-left py-2"
              >
                Возможности
              </button>
              <button
                onClick={() => scrollToSection('how-it-works')}
                className="font-bold text-lg text-black text-left py-2"
              >
                Как это работает
              </button>
              <Button
                onClick={() => scrollToSection('cta')}
                className="h-12 font-bold bg-[#d4ff00] text-black border-4 border-black rounded-none shadow-[4px_4px_0_0_#1a1a1a]"
              >
                Ранний доступ
              </Button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
